// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });



// WEBPACK FOOTER //
// ./node_modules/babel-polyfill/node_modules/core-js/modules/core.regexp.escape.js